/**
 * Icon-only brand mark — the TaskMagix calendar app icon (`/favicon.png`:
 * a white calendar on a navy rounded square). Used in the COLLAPSED
 * sidebar rail, where the full wordmark <Logo> (icon + "TaskMagix" text)
 * won't fit at 68px and squashes to an unreadable sliver. Shared across
 * the three sidebar layouts (Super Admin / Admin / User) so their chrome
 * stays in sync.
 */
export function BrandMarkIcon({ className = '' }) {
  return (
    <img
      src="/favicon.png"
      alt="TaskMagix"
      className={`h-10 w-10 rounded-lg object-contain select-none ${className}`}
      draggable={false}
    />
  )
}
